<template>
  <div
    v-if="pages > 1"
    class="pagination"
  >
    <FontAwesomeIcon
      :class="current > 1 ? 'chevron' : 'chevron--hidden'"
      icon="chevron-left"
      size="lg"
      @click="initChange(current - 1)"
    />
    <span
      :class="pageClass(firstPage)"
      @click="initChange(firstPage)"
    >{{ firstPage }}</span>
    <span v-if="renderLeftEllipsis">…</span>
    <span
      v-else
      :class="pageClass(secondPage)"
      @click="initChange(secondPage)"
    >{{ secondPage }}</span>
    <span
      v-for="page of middlePages"
      :key="page"
      :class="pageClass(page)"
      @click="initChange(page)"
    >{{ page }}</span>
    <span v-if="renderRightEllipsis">…</span>
    <span
      v-else-if="rightCondition(beforeToLastPage)"
      :class="pageClass(beforeToLastPage)"
      @click="initChange(beforeToLastPage)"
    >{{ beforeToLastPage }}</span>
    <span
      v-if="rightCondition(lastPage)"
      :class="pageClass(lastPage)"
      @click="initChange(lastPage )"
    >{{ lastPage }}</span>
    <FontAwesomeIcon
      :class="current < pages ? 'chevron' : 'chevron--hidden'"
      icon="chevron-right"
      size="lg"
      @click="initChange(current + 1)"
    />
  </div>
</template>

<script>
const PAGES_ON_SIDE = 2
export default {
  props: {
    current: {
      type: Number,
      default: 1,
      validator(value) {
        return value >= 1
      }
    },
    pages: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 1
      }
    }
  },
  computed: {
    firstPage() {
      return 1
    },
    secondPage() {
      return this.firstPage + 1
    },
    middlePages() {
      const { current } = this
      const extremeLeft = current - PAGES_ON_SIDE
      const extremeRight = current + PAGES_ON_SIDE
      const middlePages = []
      for (let i = extremeLeft; i <= extremeRight; i++) {
        if (i > this.firstPage + 1 && i < this.pages - 1)
          middlePages.push(i)
      }
      return middlePages
    },
    renderLeftEllipsis() {
      return this.current - 3 > this.firstPage
    },
    renderRightEllipsis() {
      return this.current + 3 < this.pages
    },
    beforeToLastPage() {
      return this.pages - 1
    },
    lastPage() {
      const { pages } = this
      return pages === 1 ? null : pages
    }
  },
  methods: {
    initChange(page) {
      if (page !== this.current
        && page >= 1
        && page <= this.pages
      ) this.$emit('change', page)
    },
    pageClass(page) {
      return page === this.current ? 'page--selected' : 'page'
    },
    rightCondition(page) {
      return page !== this.firstPage
        && page !== this.secondPage
    }
  }
}
</script>

<style scoped>

.pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 0.25rem;
}

.pagination * {
  margin: 0 0.4rem;
}

.chevron {
  padding: 0.5rem 1rem;
  margin: 0 0.8rem;
  color: #3b3b3b;
  background-color: #fff;
  border-radius: 10%;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.chevron--hidden {
  padding: 0.5rem 1rem;
  margin: 0 0.8rem;
  visibility: hidden;
}

.page,
.page--selected {
  padding: 0.2rem 0.4rem;
  margin: 0;
  font-size: 1.2em;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.page--selected {
  color: #f18731;
  background-color: #ffffff;
  border-radius: 10%;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}
</style>
